<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "No Show Tokens",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "No Show Tokens",
            items: [
               {
                  text: "No Show Tokens",
                  href: "/No Show Tokens",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            payment: {
               amount: 2250,
               payment_id: '',
               notes: '',
            },
            token: '',
            errors: {},

         };
      },
      mounted() {
    
      },

      methods: {
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },     
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <router-link :to="{ name: 'doctors.tokens' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                    <div class="col-md-4">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Meena                                     
                                    <span class="badge bg-primary rounded-pill">33</span>
                                </p> 
                                 </div>
                            
                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Age: 34 | Female</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <!-- <span class="float-end me-3"> -->
                                    <b-button variant="primary" v-b-modal.cancel-modal class="btn-sm mt-2 mr-1">Recall</b-button> 
                                 <!-- </span> -->
                                 </div>
                              </div>
                           </div>
                        </div>
                    </div>
                    
                     <!-- <div class=" col-lg-5 col-md-5">
                        

                        <b-card header-class="bg-transparent border-light" class="border border-light">  
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Pending Amount Details</h4>                         
                           <b-row>

                              <b-col md="12">
                                 <h5>Doctor Name:</h5>
                                 <p>Dr. Prasad Varkey</p>

                                 <h5>Total Amount</h5>
                                 <p>Rs. 2500</p>

                                 <h5>Amount to be Paid</h5>
                                 <p>Rs. 2250</p>

                                 <h5>Commission</h5>
                                 <p>Rs. 250</p>
                              </b-col>    

                           </b-row>
                           <b-button v-b-modal.payment-modal variant="primary" class="btn-sm mt-2 mr-1">Add Payment</b-button>
                        </b-card>

                     </div> -->

                     <!-- <div class="col-lg-7 col-md-7">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Consultations</h4>
                           
                           <b-row>

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>   

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>     

                           </b-row>
                        </b-card>
                      

                      

                     </div> -->
                     
                  </div>
                  <div class="row">

                  <div class="col-md-4">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Vijesh <span class="badge bg-primary rounded-pill">40</span>
                                </p> 
                                 </div>
                            
                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Age: 26 | Male</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <!-- <span class="float-end me-3"> -->
                                    <b-button variant="primary" v-b-modal.cancel-modal class="btn-sm mt-2 mr-1">Recall</b-button> 
                                 <!-- </span> -->
                                 </div>
                              </div>
                           </div>
                        </div>
                    </div>
                </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
